export default __webpack_public_path__ + "static/media/secGuard.7f1ca2d3.jpg";